(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jenpharm-faqs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-jp-faqs]').forEach(function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';
      root.querySelectorAll('.jp-faqs__item').forEach(function (it) {
        var q = it.querySelector('.jp-faqs__q'), a = it.querySelector('.jp-faqs__a');
        if (!q || !a) return;
        q.addEventListener('click', function () {
          var open = q.getAttribute('aria-expanded') === 'true';
          q.setAttribute('aria-expanded', String(!open));
          q.classList.toggle('is-open', !open);
          a.hidden = open;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jenpharm-review-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-jp-revw]').forEach(function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';
      var cards = root.querySelectorAll('.jp-revw__card');
      var empty = root.querySelector('[data-revw-empty]');
      root.querySelectorAll('.jp-revw__filter').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var f = btn.getAttribute('data-filter');
          root.querySelectorAll('.jp-revw__filter').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          var shown = 0;
          cards.forEach(function (c) {
            var show = f === '__all' || c.getAttribute('data-cat') === f;
            c.hidden = !show; if (show) shown++;
          });
          if (empty) empty.hidden = shown !== 0;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jenpharm-store-locator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-loc]').forEach(function (root) {
      var provinceSel = root.querySelector('[data-loc-province]');
      var searchInput = root.querySelector('[data-loc-search]');
      var submit = root.querySelector('[data-loc-submit]');
      var stores = Array.prototype.slice.call(root.querySelectorAll('[data-loc-store]'));
      var countEl = root.querySelector('[data-loc-count]');
      var emptyEl = root.querySelector('[data-loc-empty]');

      // Build the province dropdown from the store blocks (unique, sorted).
      if (provinceSel) {
        var seen = {};
        stores.forEach(function (s) {
          var p = (s.getAttribute('data-province') || '').trim();
          if (p && !seen[p]) { seen[p] = true; }
        });
        Object.keys(seen).sort().forEach(function (p) {
          var opt = document.createElement('option');
          opt.value = p;
          opt.textContent = p.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
          provinceSel.appendChild(opt);
        });
      }

      function apply() {
        var prov = provinceSel ? provinceSel.value : '__all';
        var q = searchInput ? searchInput.value.trim().toLowerCase() : '';
        var shown = 0;
        stores.forEach(function (s) {
          var okP = prov === '__all' || (s.getAttribute('data-province') || '') === prov;
          var okQ = !q || (s.getAttribute('data-text') || '').indexOf(q) !== -1;
          var show = okP && okQ;
          s.hidden = !show;
          if (show) shown++;
        });
        if (countEl) countEl.textContent = shown;
        if (emptyEl) emptyEl.hidden = shown !== 0;
      }

      if (provinceSel) provinceSel.addEventListener('change', apply);
      if (searchInput) {
        searchInput.addEventListener('input', apply);
        searchInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
      }
      if (submit) submit.addEventListener('click', apply);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
